import React from "react";
import { ChevronDown, ChevronRight, FolderIcon } from "lucide-react";
import { Toggle } from "@/components/feature/layout/toggle";
import { FolderItem } from "@/types/fse";
import { FlattenedItem } from "@/modules/chat/chat-ui.types";

interface FolderItemProps {
  item: FlattenedItem & FolderItem;
  toggleFolder: (folderId: string) => void;
  handleFolderToggle: (folderId: string) => void;
  getFolderSelectionState: (folderId: string) => "all" | "some" | "none";
}

export const FolderItemComponent: React.FC<FolderItemProps> = ({
  item,
  toggleFolder,
  handleFolderToggle,
  getFolderSelectionState,
}) => {
  const selectionState = getFolderSelectionState(item.id);
  const isSelected = selectionState === "all";

  return (
    <div style={{ paddingLeft: `${item.depth * 10}px` }}>
      <div className="group flex items-center gap-3 rounded-lg border border-gray-200 bg-white p-3 shadow-sm transition-all duration-200 hover:border-gray-300 hover:shadow-md">
        <button
          onClick={() => toggleFolder(item.id)}
          className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-md transition-colors hover:bg-gray-100 focus:outline-none"
          aria-label={item.isExpanded ? "Collapse folder" : "Expand folder"}
        >
          {item.isExpanded ? (
            <ChevronDown size={16} className="text-gray-500" />
          ) : (
            <ChevronRight size={16} className="text-gray-500" />
          )}
        </button>
        <FolderIcon className="h-5 w-5 flex-shrink-0 text-yellow-500" />
        <span className="min-w-0 flex-grow truncate text-sm font-medium text-gray-800" title={item.name}>
          {item.name}
        </span>
        <div className="flex-shrink-0">
          <Toggle enabled={isSelected} size="xs" onChange={() => handleFolderToggle(item.id)} />
        </div>
      </div>
    </div>
  );
};
